import React from "react";
import { Typography, Box } from "@mui/material";
import Header from '../header/header';
import Footer from '../commun/Footer';
import SidebarFichesMetiers from "../commun/SidebarFichesMetiers";
import "./Cgu.css";

const FicheDeveloppeurBackEnd = () => (
  <>
    <Header />
    <div className="fiche-layout">
      <Box className="fiche-main" component="section">
        <Typography variant="h5" gutterBottom>
          🔧 Recruter un Développeur Back-End
        </Typography>
        <Typography variant="h6" gutterBottom>
          Description du poste
        </Typography>
        <Typography paragraph>
          Le Développeur Back-End conçoit toute la logique "invisible" d’une application : traitement des données, API, bases de données, sécurité, authentification, performance serveur… C’est lui qui fait fonctionner l’application derrière l’interface utilisateur. Il joue un rôle clé dans la robustesse, la scalabilité et la sécurité du système.
        </Typography>
        <Typography variant="h6" gutterBottom>
          Missions principales
        </Typography>
        <ul className="cgu-list">
          <li>Développer des API REST ou GraphQL pour alimenter les interfaces front</li>
          <li>Gérer les bases de données (création, requêtage, optimisation)</li>
          <li>Implémenter la logique métier et les règles de sécurité</li>
          <li>Assurer l’authentification, la gestion des sessions et des rôles</li>
          <li>Optimiser les performances serveur et la scalabilité</li>
          <li>Collaborer avec les équipes Front-End, DevOps et produit</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Compétences clés
        </Typography>
        <ul className="cgu-list">
          <li>Langages : Node.js, Python, PHP, Java, Ruby (selon stack)</li>
          <li>Bases de données : PostgreSQL, MySQL, MongoDB, Redis</li>
          <li>Outils : Docker, Git, Postman, Swagger</li>
          <li>Frameworks : Express, Django, Laravel, Spring Boot…</li>
          <li>Maîtrise des notions de sécurité, performance, architecture logicielle</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Profils recherchés / Niveaux d’expérience
        </Typography>
        <ul className="cgu-list">
          <li>Junior : développement de routes simples, requêtes de base, collaboration front</li>
          <li>Confirmé : API complexes, sécurité, intégration de services tiers</li>
          <li>Senior : architecture back-end, haute disponibilité, gestion de microservices</li>
        </ul>
        <Typography variant="h6" gutterBottom>
          Tarifs / TJM indicatifs
        </Typography>
        <ul className="cgu-list">
          <li>Junior : 350–450 € / jour</li>
          <li>Confirmé : 500–650 € / jour</li>
          <li>Senior / Architecte : 700–900 € / jour</li>
        </ul>
      </Box>
      <Box className="fiche-sidebar" component="aside">
        <SidebarFichesMetiers />
      </Box>
    </div>
    <Footer />
  </>
);

export default FicheDeveloppeurBackEnd;
